const Style = {
  helper: 'p-4 mb-4 rounded bg-blue-50',
  icon: 'float-left mr-3',
  link: 'no-underline hover:underline',
};

export default Style;
